// Vendor Libraries
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {get, includes, isEmpty, map, mapValues, pickBy} from 'lodash';

// Components
import Checkbox from '../core/checkbox';
import Error from '../core/error';
import Form from '../core/form';
import RecordDetails from '../core/record-details';

// Containers
import withForm from '../../containers/with-form';

// Styles
import './remember-mapping.scss';

const formName = 'rememberMapping';

class RememberMapping extends Component {
    componentDidMount() {
        this.setFormData();
    }

    componentDidUpdate(nextProps) {
        const {mediaItemData} = this.props;

        if (nextProps.mediaItemData.guid && mediaItemData.guid !== nextProps.mediaItemData.guid) {
            this.setFormData(nextProps);
        }
    }

    getRecordDetailsMandatoryProps() {
        const {mediaItemData} = this.props;

        return {
            className: 'remember-mapping--record-details',
            noDetailExpand: true,
            searchData: [
                pickBy(
                    {
                        ...mapValues(
                            {
                                franchiseEchostarId: 'franchiseEchostarId',
                                episodeEchostarId: 'episodeEchostarId',
                                echostarId: 'echostarId',
                                network: 'externalNetwork.network.name',
                                provider: 'externalNetwork.provider.name',
                                service: 'service.serviceName',
                                matureContent: 'matureContent',
                            },
                            (value) => get(mediaItemData, value)
                        ),
                    },
                    (value) => value !== undefined
                ),
            ],
        };
    }

    getRecordDetailsSelectableProps(readOnly) {
        const {formData, selectableFields} = this.props;
        const mediaItemData = this.getSelectableFields();

        return {
            className: 'remember-mapping--record-details',
            detailStartRenderer: !readOnly ? this.detailStartRenderer : undefined,
            noDetailExpand: true,
            searchData: [
                readOnly ? pickBy(mediaItemData, (value, key) => value && get(formData.values, key)) : mediaItemData,
            ],
            whitelistKeys: selectableFields,
        };
    }

    getSelectableFields(props = this.props) {
        return pickBy(
            props.mediaItemData,
            (value, key) =>
                value &&
                includes(
                    [
                        'title',
                        'showName',
                        'description',
                        'originalAirDate',
                        'episodeName',
                        'seasonNumber',
                        'episodeNumber',
                        'duration',
                        'releaseYear',
                        'rating',
                        'actors',
                        'lang',
                        'releaseYear',
                        'starRating',
                    ],
                    key
                ),
        );
    }

    setFormData(props = this.props) {
        props.setFieldValues(
            mapValues(this.getSelectableFields(props), (_value, key) =>
                includes(['duration', 'actors', 'originalAirDate'], key) ? undefined : key
            ),
        );
    }

    detailStartRenderer(detail, key, _label, elementId) {
        return detail ? (
            <div className="remember-mapping--detail-start">
                <Checkbox className="remember-mapping--checkbox" id={elementId} name={key} value={key} />
            </div>
        ) : null;
    }

    validateFormData() {
        const {formData} = this.props;

        return isEmpty(pickBy(formData.values, (value) => value))
            ? 'At least one field is required for Map & Remember rule creation.'
            : null;
    }

    renderForm() {
        const {fetched} = this.props;

        return !fetched ? (
            <Form name={formName}>
                <RecordDetails {...this.getRecordDetailsSelectableProps()} />
            </Form>
        ) : (
            <RecordDetails {...this.getRecordDetailsSelectableProps(true)} />
        );
    }

    renderResponse() {
        const {response} = this.props;

        return map(response, (response, index) => (
            <div className="remember-mapping--message" key={index}>
                {response}
            </div>
        ));
    }

    render() {
        const {fetched} = this.props;
        const message = fetched
            ? 'Map & Remember rule created using criteria:'
            : 'Select fields to match for Map & Remember rule:';

        return (
            <div className="remember-mapping">
                <div className="remember-mapping--message">{message}</div>
                <RecordDetails {...this.getRecordDetailsMandatoryProps()} />
                {this.renderForm()}
                {this.renderResponse()}
                <Error className="remember-mapping--error" error={this.validateFormData()} />
            </div>
        );
    }
}

RememberMapping.propTypes = {
    episodeEchostarId: PropTypes.string,
    fetched: PropTypes.bool,
    formData: PropTypes.object.isRequired,
    franchiseEchostarId: PropTypes.string,
    mediaItemData: PropTypes.object.isRequired,
    response: PropTypes.array,
    selectableFields: PropTypes.array,
    setFieldValues: PropTypes.func.isRequired,
};

export default withForm(RememberMapping, formName);
